import { initI18n } from '@wix/fe-essentials/i18n';
import { EditorHost } from './types';

/** Studio 2 reuses the odeditor repluggable bundle and OD locale strings. */
const EDITOR_HOST_LOCALE_ALIASES = {
  [EditorHost.studiotwo]: EditorHost.odeditor
};
const resolveEditorHostForMessages = editorHost => EDITOR_HOST_LOCALE_ALIASES[editorHost] ?? editorHost;
const getEditorMessages = async (locale, editorHost) => {
  const messageEditorHost = resolveEditorHostForMessages(editorHost);
  try {
    return await import(`../assets/locale/${messageEditorHost}/messages_${locale}.json`);
  } catch (error) {
    // Fallback to English if the locale doesn't exist
    if (locale !== 'en') {
      try {
        return await import(`../assets/locale/${messageEditorHost}/messages_en.json`);
      } catch (fallbackError) {
        return {};
      }
    }
    return {};
  }
};
const getCommonMessages = async locale => {
  try {
    return await import(`../assets/locale/common/messages_${locale}.json`);
  } catch (error) {
    // Fallback to English if the locale doesn't exist
    if (locale !== 'en') {
      try {
        return await import(`../assets/locale/common/messages_en.json`);
      } catch (fallbackError) {
        return {};
      }
    }
    return {};
  }
};
export const getMessages = async (locale, editorHost) => {
  const [commonMessages, editorMessages] = await Promise.all([getCommonMessages(locale), getEditorMessages(locale, editorHost)]);
  return {
    ...commonMessages,
    ...editorMessages
  };
};
export const initializeI18n = (locale, editorHost, options) => {
  const isKeysMode = locale === 'keys';
  return initI18n({
    ...options,
    asyncMessagesLoader: () => isKeysMode ? Promise.resolve({}) : getMessages(locale, editorHost),
    bindI18n: 'languageChanged',
    locale: isKeysMode ? 'cimode' : locale,
    useSuspense: true
  });
};
//# sourceMappingURL=i18n.js.map